module.exports = __webpack_public_path__ + "static/media/track.b4c630af.svg";